import React from 'react';
import Media from 'react-media';
import { Link } from 'react-router-dom';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import { ImageResizer } from '../../Types/ImageResizer';

import './WhoWeAre.scss';

interface WhoWeAreProps {
	title: string;
	titleUa: string;
	subTitle: string;
	subTitleUa: string;
	image: ImageResizer;
	buttonText: string;
	buttonTextUa: string;
}

export default function WhoWeAre({ title, titleUa, subTitle, subTitleUa, image, buttonText, buttonTextUa }: WhoWeAreProps) {
	const [language] = useSessionStorage('language', '');
	return (
		<Media query="(max-width: 550px)">
			{(matches) => (
				<div className="whoWeAre">
					{matches && <div className="whoWeAreTitle">{language === 'ua' ? titleUa : title}</div>}
					<img className="whoWeAreImage" src={image.md.src} alt="" />
					<div className="whoWeAreInfo">
						{!matches && <div className="whoWeAreTitle">{language === 'ua' ? titleUa : title}</div>}
						<div
							className="whoWeAreDescription"
							dangerouslySetInnerHTML={{ __html: `${language === 'ua' ? subTitleUa : subTitle}` }}
						></div>
						<Link to="/about" className="whoWeAredButton">
							{language === 'ua' ? buttonTextUa : buttonText}
						</Link>
					</div>
				</div>
			)}
		</Media>
	);
}
